export const RESTAURANT_SERVICE_TYPES = {
  STORE: "STORE",
  DELIVERY: "DELIVERY",
};
